import { useState } from "react";
import Products from "./Products";
import Plants from "./Plants";
import RetailerCities from "./RetailerCities";
import Careers from "./Careers";
import Contact from "./Contact";
import Feedback from "./Feedback";
import bot from '../images/happy.png';

function Mainmenu() {
  const [activeFrames, setActiveFrames] = useState([{ id: 1, component: "Frame5" }]); // Root frame

  const handleShowFrame = (parentId, frameName) => {
    setActiveFrames((prevFrames) => [
      ...prevFrames,
      { id: prevFrames.length + 1, parentId, component: frameName },
    ]);
  };
const [time] = useState(new Date());
  const renderFrame = (frame) => {
    let FrameComponent = null;
    switch (frame.component) {
      case "Products":
        FrameComponent = Products;
        break;
      case "Plants":
        FrameComponent = Plants;
        break;
      case "RetailerCities":
        FrameComponent = RetailerCities;
        break;
      case "Careers":
        FrameComponent = Careers;
        break;
        case "Contact":
            FrameComponent = Contact;
            break;
            case "Feedback":
                FrameComponent = Feedback;
                break;
      default:
        return null;
    }

    return <FrameComponent key={frame.id} handleShowFrame={handleShowFrame} parentId={frame.id} />;
  };

  return (
    <>

        <div className='chatbot'>
            <img src={bot} alt="bot" className="bot" />
            <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
          </div>
      <div className="frame1 animated-frame">
        {/* <img src={image} className="IMAGE" alt="img" /> */}
        <div className="box1">
          Thank You! Team Dodla Dairy is here to resolve all your queries
          Please choose an option below:
          <div style={{textAlign: "center"}}>
            <button className="menu-btn" onClick={() => handleShowFrame(1, "Products")}>
              Explore Products
            </button>
            <button className="menu-btn" onClick={() => handleShowFrame(1, "Plants")}>
              Our Plants
            </button>
            <button className="menu-btn" onClick={() => handleShowFrame(1, "RetailerCities")}>
              Delivery Partners
            </button>
            <button className="menu-btn" onClick={() => handleShowFrame(1, "Careers")}>
              Careers
            </button>
            <button className="menu-btn" onClick={() => handleShowFrame(1, "Contact")}>
              Contact Us
            </button>
            <button className="menu-btn" onClick={() => handleShowFrame(1, "Feedback")}>
              Feedback
            </button>
          </div>
        </div>
      </div>

      {/* Render all active frames in their proper order */}
      {activeFrames.slice(1).map(renderFrame)}
    </>
  );
}

export default Mainmenu;
